import { fromNano } from "@ton/ton";
import Decimal from "decimal.js";

export const formatNanoTon = (amount: string, decimalPlaces = 2): string => {
  const ton = fromNano(amount);
  const decimal = new Decimal(ton);

  return decimal.toDecimalPlaces(decimalPlaces).toString();
};
